import { render, staticRenderFns } from "./Join-form.vue?vue&type=template&id=bc8ebe9a&scoped=true&"
import script from "./Join-form.vue?vue&type=script&lang=js&"
export * from "./Join-form.vue?vue&type=script&lang=js&"
import style0 from "./Join-form.vue?vue&type=style&index=0&id=bc8ebe9a&prod&lang=scss&"
import style1 from "./Join-form.vue?vue&type=style&index=1&id=bc8ebe9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8ebe9a",
  null
  
)

export default component.exports